module.exports = __webpack_public_path__ + "static/media/audiotrackbar-grey.97bd91e7.png";